import create from 'zustand';
import {
    persist,
    devtools
} from "zustand/middleware"
import { getCountries } from '../adapters/utils';


let store = (set) => ({
    loading: false,
    message: null,
    countries: [],
    languages: [],
    redirects: [],
    accounts: [],
    addRedirects: (payload) => set(state => ([
        ...state.redirects, payload
    ])),
    removeRedirect: (payload) => set(state => () => {
        state.redirects = state.redirects.filter((rd) => rd !== payload );
    }),
    clearRedirects: (payload) => set(state => ({
        redirects: []
    })),
    setCountries: (payload) => set(state => ({
        countries: payload
    })),
    setAccounts: (payload) => set(state => ({
        accounts: payload
    })),
    setLanguages: (payload) => set(state => ({
        languages: payload
    })),
    setLoading: (payload) => set(state => ({
       loading: payload
    })),

});

store = devtools(store);

store = persist(store, {
    name: 'ur-state'
});

const useStore = create(store);

export default useStore;